import React from 'react'
import {Routes} from 'react-router-dom'
import {
  PermissionAction,
  PermissionResource
} from '../../data/workbench-api/generated/types'
import {PrivateRoute} from '../../lib/router'
import {OrganisationNode} from '../../organisation'
import {Group} from './group'
import {PermissionOverview} from './overview'
import {Role} from './role'

export const Permissions = ({
  organisation
}: {
  organisation: OrganisationNode
}) => {
  return (
    <Routes>
      <PrivateRoute
        path="/*"
        permissionCheck={[
          PermissionResource.BusinessUser,
          PermissionAction.View
        ]}
        render={() => <PermissionOverview organisation={organisation} />}
      />
      <PrivateRoute
        path="group/:id"
        permissionCheck={[PermissionResource.Group, PermissionAction.View]}
        render={({id}) => <Group id={id} organisation={organisation} />}
      />
      <PrivateRoute
        path="group"
        permissionCheck={[PermissionResource.Group, PermissionAction.View]}
        render={() => <Group organisation={organisation} />}
      />
      <PrivateRoute
        path="role/:id"
        permissionCheck={[PermissionResource.CustomRole, PermissionAction.View]}
        render={({id}) => <Role id={id} organisation={organisation} />}
      />
      <PrivateRoute
        path="role/"
        permissionCheck={[PermissionResource.CustomRole, PermissionAction.View]}
        render={() => <Role organisation={organisation} />}
      />
    </Routes>
  )
}
